export var getDefaultRequestInit = function (method, body, headers) {
    var requestInit = { method: method };
    if (!!headers) {
        requestInit.headers = headers;
    }
    if (!!body) {
        requestInit.body = JSON.stringify(body);
    }
    return requestInit;
};
